import { fetchingAPI, apiService } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'

import { setLoading, setData, setAuditLog, setError } from './supportAccess.redux'

export const fetchSupportAccess = (orgId) => async (dispatch) => {
  dispatch(setLoading(true))
  try {
    const response = await fetchingAPI(
      `${apiService.core}/api/organizations/${orgId}/support_access`,
      'GET',
      dispatch
    )
    dispatch(setData({ ...response, orgId }))
  } catch (error) {
    dispatch(setError({ kind: 'fetchFailed', detail: error?.message }))
  } finally {
    dispatch(setLoading(false))
  }
}

export const openSupportAccess = (orgId) => async (dispatch) => {
  dispatch(setLoading(true))
  try {
    const response = await fetchingAPI(
      `${apiService.core}/api/organizations/${orgId}/support_access`,
      'POST',
      dispatch
    )
    dispatch(setData({ ...response, orgId }))
    toast.success(`Support window opened at ${new Date().toLocaleString()}`)
  } catch (error) {
    dispatch(setError({ kind: 'openFailed', detail: error?.message }))
    toast.error('Failed to open support access.', { cause: error })
  } finally {
    dispatch(setLoading(false))
  }
}

export const fetchSupportAccessAudit = (orgId) => async (dispatch) => {
  try {
    const response = await fetchingAPI(
      `${apiService.core}/api/organizations/${orgId}/support_access/audit`,
      'GET',
      dispatch
    )
    dispatch(setAuditLog(response))
  } catch {
    // Audit log is supplementary — swallow fetch errors silently.
  }
}

export const closeSupportAccess = (orgId) => async (dispatch) => {
  dispatch(setLoading(true))
  try {
    await fetchingAPI(
      `${apiService.core}/api/organizations/${orgId}/support_access`,
      'DELETE',
      dispatch
    )
    dispatch(setData({ support_access_until: null, orgId }))
    toast.success(`Support window closed at ${new Date().toLocaleString()}`)
  } catch (error) {
    dispatch(setError({ kind: 'closeFailed', detail: error?.message }))
    toast.error('Failed to close support access.', { cause: error })
  } finally {
    dispatch(setLoading(false))
  }
}
